import React from 'react';
import { Card, Image } from 'react-bootstrap';

/* Cards appearing in the Home page inside the Carousel*/

const ContentCard = ({ icon, title, description }) => {
  return (
    <Card className="mb-3" style={{width: "100%"}}>
      <Card.Body className="d-flex" style={{backgroundColor: "#ffffff"}}>
        <div className="image mr-3">
          <Image
          className="icon border"
          style={{ padding: '5px', height: '100px', width: '100px', margin: '10%'}}
          src={icon} alt={title} />
        </div>
        <div>
          <Card.Text style={{ marginLeft: "5%" , textAlign: 'justify', color:"#4472c4"}}>
            {description}
          </Card.Text>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ContentCard;
